import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "../api/axios";
import userStore from "../../../zustand/userStore";
import AllFeatureDataTable from "../../../GuiComponents/AllFeatureDataTable.table";

const CompletedQuizzes2 = () => {
  const [quizzes, setQuizzes] = useState([]);
  const [popUp, setPopUp] = useState(false);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const userData = userStore((state) => state.user);
  const location = useLocation();
  const state = location.state;
  // const state = location.state || JSON.parse(sessionStorage.getItem("currentQuiz")) || {};
  const { quizType, quiz_id } = state || {};

  useEffect(() => {
    fetchCompleted();
  }, []);

  const fetchCompleted = async () => {
    try {
      const res = await axios.get(
        // `/participant/completed-quizzes?user_id=${userData.id}`
        // `/participant/completed-quizzes?user_id=${userData.id}`,
        `/completed-quizzes?user_id=${userData.id}`
      );
      setQuizzes(res.data);
    } catch (err) {
      console.error("Error fetching completed quizzes:", err);
    }
  };

  const openPopup = async (quiz) => {
    try {
      const res = await axios.get(
        // `/participant/results?user_id=${userData.id}&quiz_id=${quiz.id}&quiz_type=${quiz.quiz_type}`
        `/results?user_id=${userData.id}&quiz_id=${quiz.id}&quiz_type=${
          quiz.quiz_type
        }&class_id=${quiz.class_id || ""}&group_id=${quiz.group_id || ""}`
      );
      console.log(res.data);
      setSelectedQuiz({
        ...res.data,
        quiz_title: quiz.title,
      });
    } catch (err) {
      console.error("Error fetching completed quizzes:", err);
    }
    setPopUp(true);
  };

  console.log(selectedQuiz);
  const closePopup = () => {
    setPopUp(false);
    setSelectedQuiz(null);
  };
  // const filteredQuizzes = quizzes?.filter((q) => {
  //   if (!searchTerm) return true; // no filter

  //   const term = searchTerm.toLowerCase();

  //   return (
  //     String(
  //       q.quiz_type === 1
  //         ? "Live Quiz"
  //         : q.quiz_type === 2
  //         ? "Practice Quiz"
  //         : "-"
  //     )
  //       .toLowerCase()
  //       .includes(term) ||
  //     String(q.title).toLowerCase().includes(term) ||
  //     String(q.status).toLowerCase().includes(term) ||
  //     new Date(q.start_date)
  //       .toLocaleString("en-IN")
  //       .toLowerCase()
  //       .includes(term) ||
  //     String(q.id).toLowerCase().includes(term)
  //   );
  // });
  //  <th>#</th>
  //                   <th>Quiz Title</th>
  //                   <th>Conducted Date Time</th>
  //                   <th>Score</th>
  //                   <th>Action</th
  const tableColumns = [
    { accessor: "slno", Header: "#" },
    { accessor: "title", Header: "Quiz Title" },
    ...(searchTerm === "" || searchTerm === "1" || searchTerm === "3"
      ? [{ accessor: "conducted_at", Header: "Conducted Date Time" }]
      : []),
    { accessor: "score", Header: "Score" },
    { accessor: "action", Header: "Action" },
  ];
  const tableData = quizzes.map((e, index) => ({
    slno: index + 1,
    title: e.title || "-",
    conducted_at: e.start_date
      ? // ? new Date(e.start_date).toLocaleString()
        formatUTCToIST(e.start_date)
      : "N/A",
    quiz_type: e.quiz_type,
    score: e.score || "-",
    action: (
      <img
        width="20"
        height="20"
        src="https://img.icons8.com/ios-glyphs/30/visible--v1.png"
        alt="visible--v1"
        style={{ cursor: "pointer" }}
        onClick={() => openPopup(e)}
      />
    ),
  }));
  function formatUTCToIST(input) {
    const date = new Date(input);

    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };

    const parts = date.toLocaleString("en-GB", options).replace(",", "");
    // en-GB gives dd/mm/yyyy by default

    // Convert "11/12/2025 10:35 am" → "11/12/2025 at 10:35 AM"
    const [d, t, a] = parts.split(" ");
    return `${d} at ${t} ${a.toUpperCase()}`;
  }
  return (
    <div>
      <h3 style={{ fontSize: "16px" }}>
        <strong>Completed Quizzes</strong>
      </h3>

      {tableData && tableData.length > 0 ? (
        <div
          style={{
            width: "100%",
            padding: "20px",
            height: "75vh",
            overflow: "auto",
            border: "1px solid rgb(230,233,237)",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "2%",
              width: "100%",
              // border: "1px solid black",
            }}
          >
            <p>
              <strong>Quiz Type</strong>
            </p>{" "}
            <select
              // style={{ width: "10%" }}
              className="form-input small-select"
              onChange={(e) => setSearchTerm(e.target.value)}
            >
              <option value="">-- Select --</option>

              <optgroup label="Live">
                <option value="1">Academic Quiz</option>
                <option value="3">Thematic Quiz</option>
              </optgroup>

              <optgroup label="Practice">
                <option value="2">Academic Quiz</option>
                <option value="4">Thematic Quiz</option>
              </optgroup>
            </select>
            <p>
              Matched Record(s) Count &nbsp;
              <strong>
                {searchTerm
                  ? tableData.filter((e) => e.quiz_type === Number(searchTerm))
                      ?.length
                  : tableData?.length}
              </strong>
            </p>
          </div>
          <br />
          <AllFeatureDataTable
            columns={tableColumns}
            data={
              searchTerm
                ? tableData.filter((e) => e.quiz_type === Number(searchTerm))
                : tableData
            }
            customPlaceHolder={"search"}
          />
        </div>
      ) : (
        <p style={{ textAlign: "center", color: "red", fontSize: "16px" }}>
          Completed Quizzes Not Found
        </p>
      )}
      <style>
        {`.small-select {

    width: 30vh !important;
    height: 6vh !important;
  }`}
      </style>
      {/* Popup Modal */}
      {popUp && selectedQuiz && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
          onClick={closePopup}
        >
          <div
            style={{
              backgroundColor: "white",
              // width: "900px",
              padding: "24px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              maxWidth: "900px",
              // width: "100%",
              position: "relative",
              height: "80vh",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={{
                position: "absolute",
                top: "10px",

                right: "15px",
                fontSize: "20px",
                fontWeight: "bold",
                color: "#555",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
              onClick={closePopup}
            >
              &times;
            </button>
            <h4 style={{ fontSize: "18px", textAlign: "center" }}>
              {/* {selectedQuiz?.quiz?.quiz_name} ( {selectedQuiz?.quiz?.quiz_type}{" "}
              ) */}
              {selectedQuiz?.quiz_title}
              {/* ( {selectedQuiz?.quiz?.quiz_type} ) */}
            </h4>
            <h4 style={{ fontSize: "18px", marginBottom: "2%" }}>
              Result Info
            </h4>
            <table className="table">
              <thead>
                <tr>
                  <th>Total Questions</th>
                  <th>Attempted</th>
                  <th>Correct</th>
                  <th>Wrong</th>
                  <th>Total Score</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{selectedQuiz?.stats?.total_questions || "-"}</td>
                  <td>{selectedQuiz?.stats?.attempted || "-"}</td>
                  <td>{selectedQuiz?.stats?.correct || "-"}</td>
                  <td>{selectedQuiz?.stats?.wrong || "-"}</td>
                  <td>{selectedQuiz?.stats?.total_score || "-"}</td>
                </tr>
              </tbody>
            </table>
            <br />{" "}
            <h4 style={{ fontSize: "18px", marginBottom: "2%" }}>
              Question Info
            </h4>
            <div style={{ height: "40vh", overflow: "auto" }}>
              <table className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Question</th>
                    <th>Correct Option</th>
                    <th>Selected Option</th>
                    <th>Time Taken</th>
                    <th>Score</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedQuiz?.answers?.map((q, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{q.question}</td>
                      <td>{q.correct_option}</td>
                      <td>
                        {q.selected_option ? (
                          <span
                            style={{
                              color:
                                q.selected_option === q.correct_option
                                  ? "green"
                                  : "red",
                            }}
                          >
                            {q.selected_option}
                          </span>
                        ) : (
                          <span
                            style={{
                              color: "orange",
                            }}
                          >
                            Not attempted
                          </span>
                        )}
                      </td>
                      <td>
                        {q.time_taken_ms
                          ? `${(q.time_taken_ms / 1000).toFixed(2)} sec`
                          : "N/A"}
                      </td>

                      <td>{q.score}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompletedQuizzes2;
